import React from 'react'
import PropTypes from 'prop-types'
import { useController, useFormContext } from 'react-hook-form'
import { Form } from 'react-bootstrap'

//import COUNTRIES_BY_ISO2 from '../ISO2CountryCodes'

import { akCountriesWithSubdivisions } from 'ak_countries'

import Field from './Field'

const ExchangeCountryCodeField = ({ availableCountryCodes, name, control, rules }) => {
  const {
    field,
    fieldState: {
      invalid,
      error,
    }
  } = useController({ name, control, rules })

  const availableCountries = akCountriesWithSubdivisions.filter(({ code }) => {
    return availableCountryCodes.includes(code)
  })

  /*
     if a country if preselected, show that in the select menu
  */
  return (
    <>
      <Form.Select {...field} isInvalid={invalid}>
        <option key='prompt'>-- Bitte auswählen --</option>
        {availableCountries.map(({ code, name }, index) => {
          return <option value={code} key={index}>{name}</option>
        })}
      </Form.Select>
      {error && (<span className='small text-danger'>{error.message}</span>)}
    </>
  )
}

const SchNetSpecificFields = ({ availableExchangeCountryCodes }) => {
  const { register, control, formState: { errors } } = useFormContext()

  return (
    <React.Fragment>
      <Form.Group className='form-group field-target-country-code' controlId='exchange_country_code'>
        <Form.Label>
          Austauschland *
        </Form.Label>
        <ExchangeCountryCodeField
          control={control}
          name='exchange_country_code'
          availableCountryCodes={availableExchangeCountryCodes}
        />
      </Form.Group>
    </React.Fragment>
  )
}

SchNetSpecificFields.propTypes = {
  availableExchangeCountryCodes: PropTypes.arrayOf(PropTypes.string)
}

export default SchNetSpecificFields
